import { application } from "./application"

import ServerFormController from "./server_form_controller"
import VotifierTestController from "./votifier_test_controller"
import VotifierSettingsController from "./votifier_settings_controller"
import NotificationSettingsController from "./notification_settings_controller"
import ThemeController from "./theme_controller"

import ConfirmDeleteController from "./confirm_delete_controller"
import ServerChartController from "./server_chart_controller"

application.register("server-form", ServerFormController)
application.register("votifier-test", VotifierTestController)
application.register("votifier-settings", VotifierSettingsController)
application.register("notification-settings", NotificationSettingsController)
application.register("confirm-delete", ConfirmDeleteController)
application.register("theme", ThemeController)
application.register("server-chart", ServerChartController)
